import { Text as RNText, type TextProps, type TextStyle, StyleSheet } from 'react-native';

import { useTheme } from '@/theme';

type Variant =
  | 'display1'
  | 'display2'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'body'
  | 'bodyLarge'
  | 'small'
  | 'eyebrow'
  | 'meta';

export type AppTextProps = TextProps & {
  variant?: Variant;
  italic?: boolean;
  tone?: 'fg' | 'fgSoft' | 'fgMute' | 'accent' | 'accentAlt' | 'invert';
  weight?: TextStyle['fontWeight'];
};

export function Text({
  variant = 'body',
  italic,
  tone = 'fg',
  weight,
  style,
  children,
  ...rest
}: AppTextProps) {
  const theme = useTheme();
  const base = theme.type[variant];
  const colorMap = {
    fg: theme.colors.fg,
    fgSoft: theme.colors.fgSoft,
    fgMute: theme.colors.fgMute,
    accent: theme.colors.accent,
    accentAlt: theme.colors.accentAlt,
    invert: theme.colors.invert,
  };

  const composedStyle: TextStyle = StyleSheet.flatten([
    base,
    { color: colorMap[tone] },
    italic && {
      fontFamily: theme.fontFamily.displayItalic,
      fontStyle: 'italic' as const,
    },
    weight && { fontWeight: weight },
    style as TextStyle,
  ]);

  return (
    <RNText style={composedStyle} {...rest}>
      {children}
    </RNText>
  );
}
